import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_SIGN_IN_STARTED_SCHEMA = Object.freeze({
  SCREEN_NAME: '',
});
const RECORD = generateSchema(TRACKING_SIGN_IN_STARTED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_SIGN_IN_STARTED_SCHEMA);

export class SignInStartedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.sign_in_started;
  }

  get properties() {
    return this.toJS();
  }
}
